import { render, staticRenderFns } from "./editShipmentCompanyForm.vue?vue&type=template&id=d481f310"
import script from "./editShipmentCompanyForm.vue?vue&type=script&lang=js"
export * from "./editShipmentCompanyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports